<script lang="ts" setup>
import { computed, toRefs, useAttrs } from 'vue'

const props = withDefaults(
  defineProps<{
    modelValue: boolean | boolean[] | string | string[]
    disabled?: boolean
    color?: string
    rules?: unknown[]
    multiple?: boolean
    hideDetails?: boolean | 'auto'
  }>(),
  {
    hideDetails: 'auto',
    multiple: false,
    rules: () => [],
    color: 'var(--color-blue-800)',
    disabled: false,
  }
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean | boolean[] | string | string[]): void
  (e: 'input', value: boolean | boolean[] | string | string[]): void
  (e: 'change', value: boolean | boolean[] | string | string[]): void
}>()

const { disabled, color, rules, multiple, hideDetails } = toRefs(props)
const attrs = useAttrs()

const value = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val)
    emit('input', val)
    emit('change', val)
  },
})
</script>

<template>
  <v-checkbox
    v-model="value"
    :color="color"
    :disabled="disabled"
    :hide-details="hideDetails"
    :multiple="multiple"
    :rules="rules"
    class="checkbox-input"
    v-bind="attrs"
  >
    <template #label>
      <slot name="label">
        <slot />
      </slot>
    </template>
  </v-checkbox>
</template>

<style lang="scss">
.checkbox-input {
  margin-top: 0;

  :deep(label) {
    color: var(--color-dark-800);
  }
}
</style>
